(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('SbfTimeSlot', SbfTimeSlot);

    SbfTimeSlot.$inject = ['$resource', 'DateUtils'];

    function SbfTimeSlot ($resource, DateUtils) {
        var resourceUrl =  'api/sbf-time-slots/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fromTime = DateUtils.convertDateTimeFromServer(data.fromTime);
                        data.toTime = DateUtils.convertDateTimeFromServer(data.toTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
